import colorPalette from '../color-palette';

const { background, text, action } = colorPalette;

export default {
  MuiSlider: {
    thumb: {
      height: 24,
      width: 24,
      backgroundColor: 'transparent',
      marginTop: -12,
      marginLeft: -12,
      '&.Mui-disabled': {
        height: 24,
        width: 24,
        backgroundColor: 'transparent',
        marginTop: -12,
        marginLeft: -12,
      },
    },
    valueLabel: {
      left: 'calc(-50% + 9px)',
      top: -22,
      '& *': {
        background: 'transparent',
        color: background.header,
      },
    },
    track: {
      height: 2,
      backgroundColor: action.active,
    },
    rail: {
      height: 2,
      opacity: 0.5,
      backgroundColor: text.secondary,
    },
    mark: {
      height: 8,
      width: 8,
      borderRadius: '50%',
      marginTop: -3,
      marginLeft: -4,
      backgroundColor: text.secondary,
    },
    markLabel: {
      color: text.secondary,
    },
    markLabelActive: {
      color: text.secondary,
    },
    markActive: {
      backgroundColor: action.active,
    },
  },
};
